<template>
  <WithCustomSidebar :config="navigation">
    <slot />
  </WithCustomSidebar>
</template>

<script>
import WithCustomSidebar from '@@/layout/Sidebar/WithCustomSidebar';
import EditIcon from '@/assets/icons/edit.svg';
import StatsIcon from '@/assets/icons/stats.svg';
import useAuth from '@/auth';

export default {
  name: 'WithCampaignInternalNav',
  components: {
    WithCustomSidebar,
  },
  computed: {
    navigation() {
      const { user } = useAuth();
      return {
        key: 'search-ads-sidebar',
        backButton: {
          route: user.isAdvertisementAdmin
            ? 'advertisement-manage-campaigns'
            : 'discovery-ads-campaigns-list',
          title: 'ADVERTISEMENT.TITLE',
        },
        items: [
          {
            route: 'discovery-ads-campaign-info',
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.INFO.TITLE',
            icon: EditIcon,
          },
          {
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.TITLE',
            route: 'discovery-ads-campaign-stats-overall',
            icon: StatsIcon,
          },
        ],
      };
    },
  },
};
</script>
